export const apiBaseEndpoint = 'http://localhost:8000';
export const apiEndPoint = apiBaseEndpoint + '/api';

